import { useReducer, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import { getAPIUrl, notify, RESTRICTED_DOMAINS } from "../components/common/helpers";
import { getAuthToken } from "../api/api";
import { ReactComponent as Close } from "../../src/icons-svg/icons/close.svg";
import axios from "axios";
import "../styles/Modal.css";
import CreatableSelect from "react-select/creatable";
import { DraggableModalDialog } from "../components/common/DraggableModal";
import { ReactComponent as Trash } from "../../src/icons-svg/icons/trash.svg";
import { getUserDetails } from "../components/sidebar/Sidenav";

import styled from "styled-components";

const StyledButton = styled.div`
  .btn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
  
  .Deletebtn {
    background: transparent;
    border: none;
    color: white;
  }
  .Deletebtn:hover {
    background: transparent;
    border: none;
  }
  .Deletebtn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;

const customSelectStyles = {
    control: (base) => ({
        ...base,
        minHeight: "32px",
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "2px 8px",
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "32px",
    }),
    input: (base) => ({
        ...base,
        margin: "0px",
        padding: "0px",
    }),
    multiValue: (base) => ({
        ...base,
        margin: "2px",
    }),
};

const EmailConfiguration = (props) => {
    const { disabledFeatures } = props;
    const [activeAccordion, setActiveAccordion] = useState(null);
    const [openMenuKey, setOpenMenuKey] = useState(null); // Track which select menu is open
    const [domainErrors, setDomainErrors] = useState({
        customer: "",
        fieldTeam: "",
    });
    const [domainGroups, setDomainGroups] = useState({
        customer: {
            label: "Customer Email Domain",
            loaded: false,
            loading: false,
            domains: [],
            dropdownOptions: [],
        },
        fieldTeam: {
            label: "FieldTeam Email Domain",
            loaded: false,
            loading: false,
            domains: [],
            dropdownOptions: [],
        },
    });

    const options = [
        { value: 1, label: "Customer Email Domain" },
        { value: 2, label: "FieldTeam Email Domain" },
    ];

    const getEmailTypeFromAccordion = (key) => {
        if (key === "customer") return options[0].value;
        if (key === "fieldTeam") return options[1].value;
        return "";
    };

    const domainRegex = /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;

    const isValidDomain = (domain) => domainRegex.test(domain);

    const controller = new AbortController();

    const initialState = {
        domains: [],
        emailType: options[0].value,
        show: false,
    };

    const formReducer = (state, action) => {
        switch (action.type) {
            case "SET_DOMAINS":
                return {
                    ...state,
                    domains: action.domains,
                };

            case "SET_EMAIL_TYPE":
                return {
                    ...state,
                    emailType: action.value,
                };
            case "SET_SHOW":
                return {
                    ...state,
                    show: action.show,
                };
            case "RESET_FORM":
                return initialState;
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(formReducer, initialState);
    const { show } = state;

    const refreshDomains = async (type) => {
        const emailType = getEmailTypeFromAccordion(type);

        const [dropdownRes, listRes] = await Promise.all([
            fetchDomainsApi(emailType, 0),
            fetchDomainsApi(emailType, 1),
        ]);

        setDomainGroups((prev) => ({
            ...prev,
            [type]: {
                ...prev[type],

                dropdownOptions: (dropdownRes || []).map((d) => ({
                    label: d.domain,
                    value: d.domain,
                })),

                domains: (listRes || []).map((d) => ({
                    id: d.id,
                    value: d.domain,
                    deletable: d.deletable,
                })),

                loaded: true,
                loading: false,
            },
        }));
    };

    const handleDomainDelete = (field) => {
        const body = JSON.stringify({
            domain_id: field.id,
            title: "DomainManagement",
            updated_by: getUserDetails().username,
        });
        axios({
            method: "PATCH",
            url: getAPIUrl("deleteFunctionApi"),
            headers: { Authorization: getAuthToken() },
            signal: controller.signal,
            data: body
        })
            .then(async (resp) => {
                if (resp) {
                    await refreshDomains(activeAccordion);
                    alert("Domain Deleted Successfully");
                }
            })
            .catch((error) => {
                console.log(error);
            });

    };

    const postDomainApi = async (domain, emailType) => {
        const domainParameters = {
            domain_name: domain,
            created_by: getUserDetails()?.username || "",
            email_type: emailType,
        }
        try {
            axios({
                method: "POST",
                url: getAPIUrl("addEmailDomainApi"),
                headers: {
                    Authorization: getAuthToken(),
                },
                signal: controller.signal,
                data: domainParameters,
            })
                .then(async (res) => {
                    if (res && !res.data.code) {
                        dispatch({ type: "SET_DOMAINS", domains: [] });
                        alert("Domain Added Successfully");
                        await refreshDomains(activeAccordion);
                    } else {
                        alert("Domain Already Exists");
                    }
                })
                .catch((error) => {
                    error.message !== "canceled" && notify("submission");
                });
        } catch (error) {
            console.log("Error fetching data:" + error);
        }
    };

    const fetchDomainsApi = async (emailType, is_added) => {
        try {
            const response = await axios.get(
                getAPIUrl("getEmailDomainListApi"),
                {
                    params: { email_type: emailType, is_added: is_added },
                    headers: {
                        Authorization: getAuthToken(),
                    },
                }
            );

            const data = response?.data || [];

            if (!Array.isArray(data)) return [];

            return data.map((item) => ({
                id: item.domainId,
                domain: item.domainName,
            }));
        } catch (error) {
            console.error("Failed to fetch domains", error);
            return [];
        }
    };

    const toggleGroup = async (type) => {
        setActiveAccordion((prev) => {
            const next = prev === type ? null : type;
            dispatch({ type: "SET_DOMAINS", domains: [] });
            return next;
        });
        if (domainGroups[type].loaded || domainGroups[type].loading) return;
        const emailType = getEmailTypeFromAccordion(type);


        const [dropdownRes, listRes] = await Promise.all([
            fetchDomainsApi(emailType, 0), // dropdown
            fetchDomainsApi(emailType, 1), // added domains
        ]);
        setDomainGroups((prev) => ({
            ...prev,
            [type]: {
                ...prev[type],
                dropdownOptions: dropdownRes?.map((d) => ({
                    label: d.domain,
                    value: d.domain,
                })),
                domains: listRes?.map((d) => ({
                    id: d.id,
                    value: d.domain,
                })),

                loaded: true,
            },
        }));

    };

    const handleClose = () => {
        if (controller) {
            controller.abort();
        }
        setActiveAccordion(null);
        dispatch({ type: "SET_SHOW", show: false });
        dispatch({ type: "RESET_FORM" });
    };
    const handleShow = () => dispatch({ type: "SET_SHOW", show: true });

    const handleDomainChange = (selected) => {
        dispatch({
            type: "SET_DOMAINS",
            domains: selected || [],
        });
    };

    // Handle keyboard navigation for accordion header
    const handleAccordionKeyDown = (key, event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleGroup(key);
        }
    };

    // Handle keyboard navigation for CreatableSelect menu
    const handleSelectKeyDown = (key, event) => {
        // Alt + ArrowDown opens the menu (standard accessibility pattern)
        if ((event.altKey && event.key === 'ArrowDown') || event.key === 'ArrowDown') {
            event.preventDefault();
            setOpenMenuKey(key);
        }
        // Escape closes the menu
        if (event.key === 'Escape') {
            setOpenMenuKey(null);
        }
    };

    return (
        <>
            {" "}
            {!disabledFeatures.includes("AddSite") && (
                <Button
                    size="sm"
                    variant="secondary"
                    style={{ background: "#ffffff", color: "#000000", width: "15rem" }}
                    onClick={handleShow}
                    aria-label="Open Email Domain Configuration"
                    aria-expanded={show}
                >
                    Email Domain Configuration
                </Button>
            )}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={true}
                dialogAs={DraggableModalDialog}
                dialogClassName="email-config-modal"
                aria-labelledby="email-config-title"
            >
                <Modal.Header className="cancelButton">
                    <Modal.Title style={{ color: "#ffffff" }} id="email-config-title">
                        <Row>
                            <Col sm={{ span: 7 }}>
                                <h3>Add Domain</h3>
                            </Col>
                            <Col sm={{ offset: 3 }}>
                                <Button
                                    className="col-md-8 hoverEffect"
                                    size="sm"
                                    variant="Dark"
                                    onClick={handleClose}
                                    aria-label="Close dialog"
                                >
                                    <Close />
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ background: "#212529" }}>
                    {Object.entries(domainGroups).map(([key, group]) => {
                        const isOpen = activeAccordion === key;
                        return (
                            <div key={key} className="email-accordion-item">
                                {/* Header */}
                                <div
                                    className="accordion-header d-flex justify-content-between align-items-center"
                                    onClick={() => toggleGroup(key)}
                                    onKeyDown={(e) => handleAccordionKeyDown(key, e)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                    aria-controls={`accordion-body-${key}`}
                                >
                                    <span>{group.label}</span>
                                    <Button size="sm" variant="secondary" className="accordian-button" aria-hidden="true" tabIndex={-1}>
                                        {isOpen ? "−" : "+"}
                                    </Button>
                                </div>

                                {/* Body */}
                                {isOpen && (
                                    <div 
                                        className="accordion-body"
                                        id={`accordion-body-${key}`}
                                        role="region"
                                        aria-labelledby={`accordion-header-${key}`}
                                    >
                                        <div className="d-flex gap-2 mb-1">
                                            <label htmlFor={`domain-select-${key}`} className="visually-hidden">Add domains to {group.label.toLowerCase()}</label>
                                            <CreatableSelect
                                                inputId={`domain-select-${key}`}
                                                isMulti
                                                components={{ IndicatorSeparator: null }}
                                                value={state.domains}
                                                styles={customSelectStyles}
                                                className="select-box-container"
                                                options={group.dropdownOptions}
                                                menuIsOpen={openMenuKey === key}
                                                onMenuOpen={() => setOpenMenuKey(key)}
                                                onMenuClose={() => setOpenMenuKey(null)}
                                                onInputChange={(inputValue, actionMeta) => {
                                                    // Open menu when user starts typing
                                                    if (actionMeta.action === 'input-change') {
                                                        setOpenMenuKey(key);
                                                    }
                                                }}
                                                onChange={(selected) => {
                                                    // Defensive check when pasting multiple values
                                                    const validDomains = selected?.filter((d) => isValidDomain(d.value)) ?? [];

                                                    if (selected.length !== validDomains.length) {
                                                        notify("alert", "One or more domains are invalid and have been removed");
                                                    }

                                                    handleDomainChange(validDomains);
                                                }}


                                                onCreateOption={(inputValue) => {
                                                    const value = inputValue.trim().toLowerCase();

                                                    if (!isValidDomain(value)) {
                                                        notify("alert", "Please enter a valid domain (e.g. example.com)");
                                                        return;
                                                    }

                                                    if (RESTRICTED_DOMAINS.some((rd) => value.endsWith(rd))) {
                                                        setDomainErrors((prev) => ({
                                                            ...prev,
                                                            [key]: `Domains from ${RESTRICTED_DOMAINS.join(", ")} are not allowed.`,
                                                        }));
                                                        notify("alert", `Restricted domain detected: ${value}. This domain cannot be added.`);
                                                        return;
                                                    }

                                                    // prevent duplicates
                                                    if (state.domains.some((d) => d.value === value)) {
                                                        notify("alert");
                                                        return;
                                                    }

                                                    handleDomainChange([
                                                        ...state.domains,
                                                        { label: value, value },
                                                    ]);
                                                }}

                                                placeholder="Type to add..."
                                                classNamePrefix="react-select"
                                                aria-label={`Select or add ${group.label.toLowerCase()}`}
                                                onKeyDown={(e) => handleSelectKeyDown(key, e)}
                                            />

                                            <Button
                                                size="sm"
                                                variant="secondary"
                                                type="button"
                                                className="w-10 add-domain-btn"
                                                disabled={!state.domains.length}
                                                onClick={async () => {
                                                    if (!state.domains.length) return;

                                                    const emailType = getEmailTypeFromAccordion(key);
                                                    const domainsToAdd = state.domains.map((d) => d.value.toLowerCase());
                                                    await postDomainApi(domainsToAdd.join(","), emailType);
                                                }}
                                                aria-label={`Add selected domains to ${group.label.toLowerCase()}`}
                                            >
                                                Add
                                            </Button>
                                        </div>
                                        {group.loading && (
                                            <div className="text-muted" role="status" aria-live="polite">Loading domains...</div>
                                        )}

                                        {!group.loading && group.domains.length === 0 && (
                                            <div className="text-muted" role="status">No domains added</div>
                                        )}

                                        <div className="domain-list-scroll" role="list" aria-label={`List of ${group.label.toLowerCase()} domains`}>
                                            {group.domains.map((d, key) => (
                                                <div
                                                    key={d.id}
                                                    className="domain-row d-flex justify-content-between align-items-center"
                                                    role="listitem"
                                                >
                                                    <span>{d.value}</span>
                                                    <StyledButton
                                                        className="Deletebtn btn-sm"
                                                        title="Delete"
                                                        data-action="delete"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => handleDomainDelete(d)}
                                                        role="button"
                                                        tabIndex={0}
                                                        aria-label={`Delete domain ${d.value}`}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault();
                                                                handleDomainDelete(d);
                                                            }
                                                        }}
                                                    >
                                                        <Trash aria-hidden="true" />
                                                    </StyledButton>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default EmailConfiguration;
